export default "__VITE_ASSET__Ble16Nlh__"